import Gateway from "./gateway";
import GatewayDest from "./dest";
import GatewayProvider from "./provider";

export default Gateway;
export {GatewayDest, GatewayProvider};
